import React from "react";

import ImageV2 from "src/components/image/image.v2";
import Suspense from "src/components/suspense/suspense";
import Swiper from "src/components/swiper";

class ImageSlide extends React.Component<{
    backgroundImagePosition: string,
    rounding: string,
    src: string,
    title: string,
}> {
    render(): React.ReactNode {
        return <>
        <div className={`hero-layer inset-0 bg-[color:var(--overlayColor)] ${this.props.rounding} overflow-hidden`}>
            <ImageV2
                style={{objectFit: "cover", objectPosition: this.props.backgroundImagePosition + " center" }}
                className={`hero-layer w-full object-cover overflow-hidden`}
                src={this.props.src}
                alt={this.props.title + ''}
            />
        </div>
        </>
    }
}



interface SliderProps {
    moduleData: {
        roundedCorners: boolean,
        bookingWidget: boolean,
        textColor: string,
        width: 'full_screen' | string,
        backgroundImages: Image[],
        backgroundImagePosition: string,
        arrow?: string,
        arrowBubble?: string,
        selectedBubbleIndicator?: string,
        unSelectedBubbleIndicator?: string,
    },
    images: Image[];
    overlayColorWithTransparency: string,
}

type Image = { position: number; directus_files_id: { filename_disk: string; title: string; }; }

interface SliderState {
    width: number | undefined;
}

export default class ImageSliderV2 extends React.Component<SliderProps, SliderState> {

    state: SliderState = {
        width: undefined,
    }

    divRef = React.createRef<HTMLDivElement>();


    get style(): React.CSSProperties & any {
        const arrowsColor = this.props.moduleData.arrow;

        return {
            '--overlayColor': this.props.overlayColorWithTransparency,
            '--swiper-pagination-color': arrowsColor,
            '--arrowsColor': arrowsColor,
        }
    }

    get rounding() {
        if (this.props.moduleData.roundedCorners && this.props.moduleData.width !== 'full_screen') return "rounded-xl";
        return "";
    }

    componentDidMount(): void {
        this.setState({ width: this.divRef.current?.offsetWidth });
    }

    render(): React.ReactNode {

        const images = [...this.props.images]
            .sort((a, b) => a.position > b.position ? 1 : -1)
            .filter((img) => img?.directus_files_id )

        const first = images[0];
        const rounding = this.rounding;

        return <>
        <div style={this.style} ref={this.divRef} className={`hero-layer absolute top-0 left-0 right-0 bottom-0 w-full h-full -z-10 ${rounding} overflow-hidden`}>
            <Suspense fallback={<ImageSlide
                    backgroundImagePosition={this.props.moduleData.backgroundImagePosition}
                    rounding={rounding}
                    src={first.directus_files_id.filename_disk}
                    title={first.directus_files_id.title} />}>
                <Swiper
                    pagination={true}
                    paginationClass={this.props.moduleData.bookingWidget ? 'pagination-with-booking' : ''}
                    navigation={true}
                    className={rounding}
                    slidesPerView={1}
                    spaceBetween={0}
                    centeredSlides={true}
                    width={this.state.width}
                    arrow_color={this.props.moduleData.arrow}
                    arrow_bubble_color={this.props.moduleData.arrowBubble}
                    selected_bubble_indicator_color={this.props.moduleData.selectedBubbleIndicator}
                    unselected_bubble_indicator_color={this.props.moduleData.unSelectedBubbleIndicator}
                >
                   {images.map((image) => <ImageSlide
                        backgroundImagePosition={this.props.moduleData.backgroundImagePosition}
                        rounding={rounding}
                        src={image.directus_files_id.filename_disk}
                        title={image.directus_files_id.title} />
                   )}
                </Swiper>
            </Suspense>
            <div className={`absolute hero-layer top-0 left-0 w-full h-full z-10 pointer-events-none bg-[color:var(--overlayColor)] ${rounding}`} />
        </div>
        </>
    }
}
